import * as Dialog from '@radix-ui/react-dialog';
import { twMerge } from 'tailwind-merge';

export type OverlayProps = Dialog.DialogOverlayProps;

export function Overlay({ className, ...props }: OverlayProps) {
  return (
    <Dialog.Overlay
      {...props}
      className={twMerge(
        'fixed inset-0 z-50 bg-[rgba(14,38,69,0.77)]',
        'data-[state=open]:animate-[overlay-fade-in_200ms_ease-out]',
        'data-[state=closed]:animate-[overlay-fade-out_150ms_ease-in]',
        className,
      )}
    />
  );
}
